import {
  Backdrop,
  CircularProgress,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

function Loading({
  open = true,
  message,
  opacity = 0.9,
  size = 100
}) {
  const { t } = useTranslation();
  const displayMessage = message ?? t('loading.data');

  return (
    <div className="survey-list__container">
      <Backdrop
        sx={{
          color: '#fff',
          backgroundColor: `rgba(0, 0, 0, ${opacity})`,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 2
        }}
        open={open}
      >
        <CircularProgress
          color="inherit"
          sx={{
            width: `${size}px !important`,
            height: `${size}px !important`,
            color: '#ffffff !important'
          }}
        />
        {displayMessage && (
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              mt: 3
            }}
          >
            {displayMessage}
          </Typography>
        )}
      </Backdrop>
    </div>
  );
}

export default Loading;